module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"product":"Artikel","countQuantity":"Zählmenge","empty":"Leergutartikel","number":"Nummer","baseUnit":"Grundeinheit","depositValue":"Pfandwert"},"en":{"product":"Product","countQuantity":"Count quantity","empty":"Empty","number":"Number","baseUnit":"Base unit","depositValue":"Deposit value"}}')
  delete Component.options._Ctor
}
